<div data-cy="configure-enrollment-offer-form">
  <app-enrollment-offer-instant-form
    *ngIf="isInstantOffer; else selectedBonus"
    [formGroup]="instantOfferForm"
  ></app-enrollment-offer-instant-form>
  <ng-template #selectedBonus>
    <app-enrollment-offer-bonus-form [formGroup]="bonusOfferForm"></app-enrollment-offer-bonus-form>
  </ng-template>
</div>
